module.exports = __webpack_public_path__ + "static/photoshoot-afea012384dc6284011cf8a06c5dff6a.png";